import React from "react";
import { modalService } from "services";
import { FA } from "components/FA";

const License = ({ close }) => (
  <>
    <h3 className="card-header">
      Technology transfer/ licensing data{" "}
      <FA title="Close" onClick={() => close()} icon="times" size="xs" />
    </h3>
    <div className="card-body">
      <p>
        A license is a contractual agreement between the owner of a patent and
        the licensee that permits the use of the patent under defined terms of
        use. There is no obligation to inform the EPO or any other authority
        about licenses of patents or of any intent to license, so licensing data
        is far from complete. KnowING IPR thus compiled information available to
        different patenting authorities (EPO for licensed/WIPO for licensable)
        and compiled other links which can allow checking for this.
      </p>
    </div>
  </>
);

const openLicenseModal = () =>
  modalService.open({
    id: "license",
    children: <License close={() => modalService.close("license")} />,
  });

export { openLicenseModal };
